import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useProjects() {
  return useSelector((state: RootState) => state.projects.projects)
}
